import { Component, OnInit } from '@angular/core';
import firebase from "firebase/app";


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    isCLosed = false;

    ngOnInit() {
        const firebaseConfig = {
            apiKey: "AIzaSyCQsTFYvH7q8MoJ2eF8sUsUXDpua2p9aQE",
            authDomain: "heat-training-sport.firebaseapp.com",
            databaseURL: "https://heat-training-sport-default-rtdb.europe-west1.firebasedatabase.app",
            projectId: "heat-training-sport",
            storageBucket: "heat-training-sport.appspot.com",
            messagingSenderId: "449042613793",
            appId: "1:449042613793:web:67ca89b007b5e1c3af0560",
            measurementId: "G-ZB7HTJ34MX"
        };
        
        // Initialize Firebase
        firebase.initializeApp(firebaseConfig);
    }

    onClose() {
        this.isCLosed = true;
     
    }
}
